// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");

var t_encode = Decco.stringToJson;

var t_decode = Decco.stringFromJson;

function fromString(x) {
  return x;
}

function obfuscate(param) {
  return "********";
}

function toString(x) {
  return x;
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.fromString = fromString;
exports.obfuscate = obfuscate;
exports.toString = toString;
/* No side effect */
